import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getIdToken } from '../../auth';
import { IDocuments, IPaging, IDownloading, IDeleted, IUpload } from '../../types/Document';
import {  IDocumentById, IHistory} from '../../types/Documentsid';
import { BASE_URL_ENDPOINT } from '../../config/env';

interface IState {
    result: IDocuments[];
    error: any | null;
  }
  const initialState: IState = {
    result: [],
    error: null,
  };

  
//   console.log('este es el token en el documentsSlice:', token);
  const repositoryName = sessionStorage.getItem('repositoryName');
  console.log("este es el repositoryName en el documentslice ****:", repositoryName);
export const fetchDeletedDocumentRequest = createAsyncThunk(
    'fetchDeletedDocumentRequest',
    async (formObjec:any) => {
      
        console.log("formData en deletedDocumentRequest formobjec:",formObjec);
        const token = getIdToken();
        const data = await fetch(`${BASE_URL_ENDPOINT}/management-ctx/api/v2/deletion-request`,{
           
        method:'POST',
            headers: {
            'Content-type':'application/json',
            'Access-Control-Allow-Origin': '*',
            'repository-name':`${repositoryName}`,
            'Authorization':`Bearer ${token}`},
             body: JSON.stringify(formObjec),    
        })
        .then(response => {
            return response.text()
          })
          .then((data) => {
            return(data)
          })
            .catch(error => {
                console.log("error:",error);
                return error;
            })
            console.log(data)
        return data
    }
)

const deleteRequestDocumentSlice= createSlice({
    name: "deleteRequestDocumentSlice",
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(
            fetchDeletedDocumentRequest.fulfilled, (state, action) => {
                state.result = action.payload.result;
                console.log("state-fetchDeletedDocumentRequest:",state.result);
                state.error = null;
            }
        );
        builder.addCase(
            fetchDeletedDocumentRequest.rejected, (state, action) => {
                state.error = action.payload;
                console.log("state-error:", state.error
                )
            }
        );
    },
});

export default deleteRequestDocumentSlice.reducer;